import React from "react";
import { Box } from "grid-styled";
import { Helmet } from "react-helmet";
import { validate as buildValidations, validators } from "validate-redux-form";
import { Field, reduxForm } from "redux-form";
import { EMAIL_REGEX } from "../utils/validation";
import { requestPasswordReset } from "../api";
import { InputContainer } from "./forms";
import Button, { LinkButton } from "./Button";
import LoginWrapper from "./LoginWrapper";

const validate = values => {
  return buildValidations(values, {
    email: validators.regex(EMAIL_REGEX)("Please enter a valid email address.")
  });
};

class ResetPassword extends React.Component {
  state = {
    submitting: false,
    submitted: false,
    error: null
  };

  onSubmit = ({ email }) => {
    this.setState({ submitting: true });
    requestPasswordReset(email)
      .then(() => {
        this.setState({ submitted: true });
      })
      .catch(error => {
        console.error(
          "There was a problem submitting the password reset request",
          error
        );
        this.setState({ submitted: false, error });
      })
      .then(() => this.setState({ submitting: false }));
  };

  render() {
    const { handleSubmit } = this.props;
    const { submitting, submitted } = this.state;

    return (
      <LoginWrapper>
        <Helmet>
          <title>Request Reset Password</title>
        </Helmet>
        {submitted ? (
          <div>Reset sent! Please check your inbox.</div>
        ) : (
          <form onSubmit={handleSubmit(this.onSubmit)}>
            <Box pb={2}>
              <Field
                size="large"
                name="email"
                labelText="Email Address"
                placeholder="e.g., john@archadeck.net"
                component={InputContainer}
              />
            </Box>
            <Box>
              <Button variant="primary" type="submit" disabled={submitting}>
                {submitting ? "Requesting..." : "Request Password Reset"}
              </Button>{" "}
              <LinkButton to="/login">Go Back</LinkButton>
            </Box>
          </form>
        )}
      </LoginWrapper>
    );
  }
}

export default reduxForm({
  form: "reset-password-request",
  validate
})(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/RequestPasswordReset.js